'use strict';

var GridFlowTypeCogButtonController = function GridFlowTypeCogButtonController($scope) {
  var gridPanel = $scope.gridPanelScope;
  $scope.cogId = 'gridToolbarFaresAverage';
  $scope.cogOptionSet = gridPanel.gridId === 'mapped-fares' ? require('../config/mappedFaresCogOptions.json') : require('../config/faresCogOptions.json');
};
GridFlowTypeCogButtonController.$inject = ['$scope'];
module.exports = GridFlowTypeCogButtonController;